import { HomeIcon } from '@heroicons/react/24/outline'

const HeadquarterChanged = ({ newName }) => (
  <div className="flex justify-center items-center">
    <HomeIcon className="h-5 w-5" />
    {newName && <p className="ml-1 lg:text-sm text-blue">{newName}</p>}
  </div>
)

export default HeadquarterChanged
